import { Popup } from "@/components/popups/Popup/Popup";
import { Loader } from "@/components/UI/Loader";
import { Button } from "@/components/buttons/Button";
import { IVerificationPopupProps } from "@/common/buses/popups/popup-types";
import { useVerificationPopup } from "@/components/popups/VerificationPopup/hooks/useVerificationPopup";
import SuccessCircleIcon from "@/common/images/icons/success-circle.svg?react";
import AlertIcon from "@/common/images/icons/alert.svg?react";
import "./VerificationPopup.scss";

export const VerificationPopup = ({ user }: IVerificationPopupProps) => {
  const {
    error,
    isLoading,
    profileVerificationDone,
    onCancelVerification,
    onStartVerification,
    onVerifyAge,
  } = useVerificationPopup();

  const renderContent = () => {
    if (isLoading) {
      return <Loader />;
    }

    if (user.verified) {
      return (
        <>
          <SuccessCircleIcon className="titleIcon success" />
          <h4 className="title">Verification Complete!</h4>
          <p>Congrats! You’re officially a RedGIFs Verified Content Creator!</p>
        </>
      );
    }

    if (profileVerificationDone) {
      if (user.ageVerified) {
        return (
          <>
            <SuccessCircleIcon className="titleIcon success"/>
            <h4 className="title">Verification Complete!</h4>
            <p>
              Thanks for submitting your verification.
              Our team will review your application within 48 hours, and you’ll receive a confirmation by email.
            </p>
            <div className="actions">
              <Button onClick={onCancelVerification}>Go to RedGIFs Lite</Button>
            </div>
          </>
        );
      }
    }

    return (
      <>
        <AlertIcon className="titleIcon" />
        <h4 className="title">Verification Required</h4>
        <p>To unlock full access to RedGIFs, you’ll need to verify your account. The application only takes a few minutes.</p>
        <div className="actions">
          <Button variant="primary" onClick={profileVerificationDone ? onVerifyAge : onStartVerification}>Get Verified Now</Button>
        </div>
      </>
    );
  };

  return (
    <Popup
      isOpen={true}
      popupClass="VerificationPopup"
    >
      <div>
        {renderContent()}
        {error && (<p className="error">{error}</p>)}
      </div>
    </Popup>
  );
};
